var ThreeDSDecorator = (function ($, _) {
	var ThreeDSDecorator = function (opts) {
		this._init = new $.Deferred();

		this.braintree = opts.Braintree;
		this.braintree.onSetupDone(this._init.resolve);
	};

	_.extend(ThreeDSDecorator.prototype, {
		verify3DS: function (nonce, amount, bin, data) {
            if (PromiseUtil.isResolved(this._init)) {
                var verify = new $.Deferred();

				var verifyCard = this.braintree.threeDS.verifyCard(amount, nonce, bin, data);
			    window.app && app.event && app.event.threeDSecureOpen();

				verifyCard.ready.then(function(form) {
					$('body').append(form);
				});
                verifyCard.verify.then(_.bind(function (payload) {
                    window.app && app.event && app.event.threeDSecurePassed();
                    verify.resolve(payload);
                }, this));
                
                return verify.promise();
			} else {
				return PromiseUtil.rejected();
			}
		}
	});

	return ThreeDSDecorator;
})($, _);